import React, { useRef, useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
//import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import Moment from 'moment';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Update from './updatefile'
import Addnewfile from './addnewfile'
import Delete from './delete'
import MultiSelect from 'react-multiple-select-dropdown-lite'
import 'react-multiple-select-dropdown-lite/dist/index.css'
import Select from 'react-select';
import { EditorState, convertFromHTML, ContentState } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { stateToHTML } from 'draft-js-export-html';

function EditOneRecord(props) {
    let [responseData, setResponseData] = React.useState("");
    let [responseID, setResponseID] = React.useState("");
    //const [subDomainOptions, setSubDomainOptions] = useState([]);
    // let [responseFile, setResponseFile] = React.useState("");
    let [agree, setAgree] = useState(false);;
    let [loading, setLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true); // Track if it's the first load
    const [editorState, setEditorState] = useState(EditorState.createEmpty()); // Default to an empty editor state
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (index) => {
        setActiveTab(index);
    };

    const handleOnchange = val => {
        setResponseData({ ...responseData, type: val })
    }

    const checkboxHandler = () => {

        setAgree(!agree);
    }

    const location = useLocation();

    // Function to get the 'id' query parameter from the URL
    const getIdFromQuery = () => {
        const params = new URLSearchParams(location.search);
        return params.get('id'); // 'id' will be the key in the query string
    };

    // Retrieve the id value
    const fetchData = React.useCallback(() => {
        const id = getIdFromQuery();  // Assuming getIdFromQuery() extracts the ID from the URL

        if (id) {
            axios({
                method: "GET",
                url: `https://fs3.acl.gov/findByElasticIDv2/${id}`
            })
                .then((response) => {
                    console.log("Test: ", response.data._source)
                    setResponseData(response.data._source);
                    setResponseID(response.data);
                    console.log("Fetched data:", response.data._source);
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    // Optionally display an error message to the user
                });
        } else {
            console.log("No ID provided in URL");
        }
    }, []);


    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Update editorState with the responseData content when it is fetched
    useEffect(() => {
        if (responseData) {
            const initialEditorStates = {};

            // Only update the editor state if it's necessary (initial load or changes in responseData)
            Object.keys(responseData).forEach((field) => {
                const fieldValue = responseData[field];

                // Check if field has HTML content
                if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim() !== "") {
                    const blocksFromHTML = convertFromHTML(fieldValue);
                    const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
                    initialEditorStates[field] = EditorState.createWithContent(contentState);
                } else {
                    initialEditorStates[field] = EditorState.createEmpty(); // Empty editor state if no content
                }
            });

            // Only set editor states if they haven't been set yet (prevent unnecessary updates)
            setEditorState((prevState) => {
                return Object.keys(initialEditorStates).reduce((acc, field) => {
                    if (!prevState[field]) {
                        acc[field] = initialEditorStates[field];
                    } else {
                        acc[field] = prevState[field];
                    }
                    return acc;
                }, {});
            });
        }
    }, [responseData]); // Run when responseData changes


    // Handle editor state changes
    const onEditorStateChange = (field, newEditorState) => {
        setEditorState((prevStates) => ({
            ...prevStates,
            [field]: newEditorState, // Update editor state for the specific field
        }));

        // Convert new editor state to HTML and update the responseData
        const newContent = newEditorState.getCurrentContent();
        const html = stateToHTML(newContent); // Convert content to HTML
        setResponseData((prevData) => ({
            ...prevData,
            [field]: html, // Update the responseData with the new HTML content
        }));
    };

    const editorRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setResponseData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSelectChange = (name, value) => {
        setResponseData((prevData) => ({
            ...prevData,
            [name]: value ? value.value : '',
        }));
    };

    const handleMultiSelectChange = (name, selectedOptions) => {
        setResponseData((prevData) => ({
            ...prevData,
            [name]: selectedOptions.map((option) => option.value),
        }));
    };

    /*  const handleDomainChange = (selectedOption) => {
         const selectedDomain = selectedOption ? selectedOption.value : '';
         setResponseData((prevData) => ({
             ...prevData,
             domain: selectedDomain,
             subDomain: '', // Reset subDomain when domain changes
         }));
 
         // Set the sub-domain options based on selected domain
         if (selectedDomain) {
             setSubDomainOptions(domainToSubDomainMapping[selectedDomain] || []);
         }
     }; */
    /*  const handleEditorChange = (content) => {
         setResponseData((prevData) => ({
             ...prevData,
             references: content,
         }));
     }; */


    const domainOptions = [
        { value: 'Maltreatment', label: 'Maltreatment' },
        { value: 'Decisional capabilities', label: 'Decisional capabilities' },
        { value: 'Functional status', label: 'Functional status' },
        { value: 'Risk assessment', label: 'Risk assessment' }
    ];

    const subDomainOptions = [
        { value: 'Maltreatment (broad)', label: 'Maltreatment (broad)' },
        { value: 'Financial', label: 'Financial' },
        { value: 'Neglect', label: 'Neglect' },
        { value: 'Physical', label: 'Physical' },
        { value: 'Psychological', label: 'Psychological' },
        { value: 'Self-neglect', label: 'Self-neglect' },
        { value: 'Sexual', label: 'Sexual' },
        { value: 'Other', label: 'Other' }
    ];

    // Define sub-domain options based on domain selection
    /*   const domainToSubDomainMapping = {
          Maltreatment: [
              { value: 'Maltreatment (broad)', label: 'Maltreatment (broad)' },
              { value: 'Physical', label: 'Physical' },
              { value: 'Psychological', label: 'Psychological' },
              { value: 'Financial', label: 'Financial' },
              { value: 'Sexual', label: 'Sexual' },
              { value: 'Neglect', label: 'Neglect' },
              { value: 'Self-neglect', label: 'Self-neglect' },
              { value: 'Social', label: 'Social' },
              { value: 'Other', label: 'Other' },
          ],
          'Decisional capabilities': [
              { value: 'General', label: 'General' },
              { value: 'Financial', label: 'Financial' },
              { value: 'Sexual consent', label: 'Sexual consent' },
          ]
      };
   */


    const fieldOptions = [
        { value: 'Social/human services', label: 'Social/human services' },
        { value: 'Research', label: 'Research' },
        { value: 'Healthcare', label: 'Healthcare' },
        { value: 'Legal', label: 'Legal' },
        { value: 'Financial services', label: 'Financial services' },

    ];

    const administeredByOptions = [
        { value: 'Professional', label: 'Professional' },
        { value: 'Proxy', label: 'Proxy' },
        { value: 'Self-administered', label: 'Self-administered' },
        { value: 'Self-administered (followed by an interview with a professional)', label: 'Self-administered (followed by an interview with a professional)' },
        { value: 'Self-administered and professional', label: 'Self-administered and professional' },
        { value: 'Caregiver', label: 'Caregiver' },
        { value: 'Unknown', label: 'Unknown' }
    ];

    const formatOptions = [
        { value: 'Questionnaire', label: 'Questionnaire' },
        { value: 'Observation', label: 'Observation' },
        { value: 'Interview/questionnaire', label: 'Interview/questionnaire' },
        { value: 'Computer-administered', label: 'Computer-administered' },
        { value: 'Rating scale', label: 'Rating scale' },
        { value: 'Vignette-based tool', label: 'Vignette-based tool' },
        { value: 'Behavioral tasks', label: 'Behavioral tasks' },
        { value: 'Performance Measure', label: 'Performance Measure' },
        { value: 'Informant', label: 'Informant' }
    ];
    const trainingRequiredOptions = [
        { value: 'No training required', label: 'No training required' },
        { value: 'Brief training required (less than 3 hours)', label: 'Brief training required (less than 3 hours)' },
        { value: 'Some training required (between 4-8 hours)', label: 'Some training required (between 4-8 hours)' },
        { value: 'Moderate training required (8-16 hours)', label: 'Moderate training required (8-16 hours)' },
        { value: 'Extensive training required (17+ hours)', label: 'Extensive training required (17+ hours)' },
        { value: 'Professional qualifications', label: 'Professional qualifications' },
        { value: 'Unknown', label: 'Unknown' },
    ];



    const copyrightAndAccessOptions = [
        { value: 'Not found', label: 'Not found' },
        { value: 'Copyrighted', label: 'Copyrighted' },
        { value: 'Not copyrighted', label: 'Not copyrighted' },
        { value: 'Write for permission to use', label: 'Write for permission to use' },
        { value: 'Give credit', label: 'Give credit' },
        { value: 'Free to use', label: 'Free to use' },
        { value: 'For purchase', label: 'For purchase' },

    ];


    const ratingresultOptions = [
        { value: 'Promising/Emerging', label: 'Promising/Emerging' },
        { value: 'Not yet established', label: 'Not yet established' },
        { value: 'Well Supported/Supported', label: 'Well Supported/Supported' },
        { value: 'Unsupported', label: 'Unsupported' },
    ];


    const levelOfEvidenceOptions = [
        { value: 'Well Supported/Supported', label: 'Well Supported/Supported' },
        { value: 'Not yet established', label: 'Not yet established' },
        { value: 'Promising/Emerging', label: 'Promising/Emerging' },
        { value: 'Unsupported', label: 'Unsupported' },
    ];

    const onSubmit = (e) => {
        setLoading({ loading: true });

        // Assuming the form has input fields for index and id, extract them from state or input
        const index = process.env.REACT_APP_NAME; // Replace `inputIndex` with your actual index value
        const fieldsToUpdate = responseData; // The fields you want to update
        const id = getIdFromQuery();
        // Prepare data to send, including index, id, and fieldsToUpdate
        const dataToSend = {
            index: index,
            id: id,
            fieldsToUpdate: fieldsToUpdate
        };
        // Make the POST request
        axios.post('https://fs3.acl.gov/updateRecord', dataToSend)
            .then((response) => {
                // Handle the response when successful
                console.log('Update successful:', response.data);

                // Optionally reload the page after 3 seconds
                setTimeout(() => {
                    window.location.reload();
                }, 3000); // Wait 3 seconds before reloading
            })
            .catch((error) => {
                // Handle errors
                console.error('Error occurred:', error.response ? error.response.data : error.message);
            })
            .finally(() => {
                // Stop the loading state
                setLoading({ loading: false });
            });
    };



    console.log("Response: ", responseData)
    return (
        <div>
            <div>

                <div className="flex space-x-4 border-b-2">
                    <button
                        className={`py-2 px-4 text-lg font-medium ${activeTab === 0 ? 'bg-gray-300 text-black' : 'bg-blue-700 text-white'
                            } rounded-t-lg`}
                        onClick={() => handleTabChange(0)}
                    >
                        Resource Materials
                    </button>
                    <button
                        className={`py-2 px-4 text-lg font-medium ${activeTab === 1 ? 'bg-gray-300 text-black' : 'bg-blue-700 text-white'
                            } rounded-t-lg`}
                        onClick={() => handleTabChange(1)}
                    >
                        Supplemental Materials
                    </button>
                </div>




                <form class="w-full" onSubmit={e => {
                    e.preventDefault();
                    onSubmit();

                    /*  window.location.reload()
                     setTimeout(function () {
                       window.location.reload();
                     }, 3000) */
                }
                }


                >
                    {activeTab === 0 && (
                        <div>
                            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 p-8">


                                <div class="form-group w-full md:w-1/2 ">
                                    <label
                                        class="block  tracking-wide text-gray-700 text-xs  mb-2"
                                        for="grid-last-name"
                                    >
                                        Created Date
                                    </label>
                                    <input
                                        class="mt-1 appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                        id="grid-last-name"
                                        type="text"
                                        value={Moment(responseData.publishedDate).format("MMMM DD YYYY")}
                                    />
                                </div>
                            </div>
                            <div class="flex flex-wrap -mx-3 mb-6 p-8">

                                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                                    <div className="form-group">
                                        <label htmlFor="toolName" className="block text-sm font-medium text-gray-700">Tool Name</label>
                                        <input
                                            type="text"
                                            id="toolName"
                                            name="toolName"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.toolName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="domain" className="block text-sm font-medium text-gray-700">Domain</label>
                                        <Select
                                            inputId="domain"
                                            options={domainOptions}
                                            value={domainOptions.find((option) => option.value === responseData.domain)}
                                            onChange={(value) => handleSelectChange('domain', value)}
                                            className="mt-1"
                                        />

                                    </div>



                                    <div className="form-group">
                                        <label htmlFor="domainSubType" className="block text-sm font-medium text-gray-700">
                                            Sub Domain <span> </span>

                                            <span className="text-xs text-gray-500 mt-1">
                                                (Select one or more options from the list.)</span></label>
                                        <Select
                                            isMulti
                                            inputId="domainSubType"
                                            options={subDomainOptions}
                                            value={subDomainOptions.filter((option) =>
                                                responseData.domainSubType && responseData.domainSubType.length > 0
                                                    ? responseData.domainSubType.includes(option.value) // Select options that are in domainSubType
                                                    : false // No default selection if domainSubType is empty
                                            )}
                                            onChange={(selectedOptions) =>
                                                handleMultiSelectChange('domainSubType', selectedOptions)
                                            }
                                            className="mt-1"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="maltreatmentSubTypeOther" className="block text-sm font-medium text-gray-700">Maltreatment SubType : Other</label>
                                        <input
                                            type="text"
                                            id="maltreatmentSubTypeOther"
                                            name="maltreatmentSubTypeOther"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.maltreatmentSubTypeOther}
                                            onChange={handleChange}
                                        />
                                    </div>


                                    <div className="form-group">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                            for="grid-first-name"
                                        >
                                            Description
                                        </label>
                                        <Editor
                                            editorState={editorState['description']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('description', newEditorState)} // Pass the field name to handle changes
                                        />
                                    </div>




                                    <div className="form-group">
                                        <label htmlFor="originalToolName" className="block text-sm font-medium text-gray-700">Name of Original Tool</label>
                                        <input
                                            type="text"
                                            id="originalToolName"
                                            name="originalToolName"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.originalToolName}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="applicableFields" className="block text-sm font-medium text-gray-700">Applicable Fields <span className="text-xs text-gray-500 mt-1">
                                        (Select one or more options from the list.)</span></label>
                                        <Select
                                            isMulti
                                            inputId="applicableFields"
                                            options={fieldOptions}
                                            value={fieldOptions.filter((option) => responseData.applicableFields && responseData.applicableFields.length > 0
                                                ? responseData.applicableFields.includes(option.value)
                                                : false
                                            )}
                                            onChange={(selectedOptions) =>
                                                handleMultiSelectChange('applicableFields', selectedOptions)
                                            }

                                            className="mt-1"
                                        />


                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="administeredBy" className="block text-sm font-medium text-gray-700">Administered By <span className="text-xs text-gray-500 mt-1">
                                        (Select one or more options from the list.)</span></label>
                                        <Select
                                            isMulti
                                            inputId="administeredBy"
                                            options={administeredByOptions}
                                            value={administeredByOptions.filter((option) => responseData.administeredBy && responseData.administeredBy.length > 0
                                                ? responseData.administeredBy.includes(option.value)
                                                : false
                                            )}
                                            onChange={(selectedOptions) =>
                                                handleMultiSelectChange('administeredBy', selectedOptions)
                                            }
                                            className="mt-1"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="administeredByDetails" className="block text-sm font-medium text-gray-700">Administered By Details</label>
                                        <input
                                            type="text"
                                            id="administeredByDetails"
                                            name="administeredByDetails"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.administeredByDetails}
                                            onChange={handleChange}
                                        />
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="format" className="block text-sm font-medium text-gray-700">Format <span className="text-xs text-gray-500 mt-1">
                                        (Select one or more options from the list.)</span></label>
                                        <Select
                                            isMulti
                                            inputId="format"
                                            options={formatOptions}
                                            value={formatOptions.filter((option) => responseData.format && responseData.format.length > 0
                                                ? responseData.format.includes(option.value)
                                                : false
                                            )}
                                            onChange={(selectedOptions) =>
                                                handleMultiSelectChange('format', selectedOptions)
                                            }
                                            className="mt-1"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="formatDetail" className="block text-sm font-medium text-gray-700">Format Detail</label>
                                        <input
                                            type="text"
                                            id="formatDetail"
                                            name="formatDetail"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.formatDetail}
                                            onChange={handleChange}
                                        />
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="numOfItems" className="block text-sm font-medium text-gray-700">Number of Items</label>
                                        <input
                                            type="text"
                                            id="numOfItems"
                                            name="numOfItems"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.numOfItems}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="adminLength" className="block text-sm font-medium text-gray-700">Administration Length</label>
                                        <input
                                            type="text"
                                            id="adminLength"
                                            name="adminLength"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.adminLength}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="trainingRequired" className="block text-sm font-medium text-gray-700">Training Required</label>
                                        <Select
                                            inputId="trainingRequired"
                                            options={trainingRequiredOptions}
                                            value={trainingRequiredOptions.find((option) => option.value === responseData.trainingRequired)}
                                            onChange={(value) => handleSelectChange('trainingRequired', value)}
                                            className="mt-1"
                                        />
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="trainingRequiredDetail" className="block text-sm font-medium text-gray-700">Training Required Detail</label>
                                        <input
                                            type="text"
                                            id="trainingRequiredDetail"
                                            name="trainingRequiredDetail"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.trainingRequiredDetail}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="language" className="block text-sm font-medium text-gray-700">Language</label>
                                        <input
                                            type="text"
                                            id="language"
                                            name="language"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.language}
                                            onChange={handleChange}
                                        />
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="copyrightAndAccess" className="block text-sm font-medium text-gray-700">Copyright And Access <span className="text-xs text-gray-500 mt-1">
                                        (Select one or more options from the list.)</span></label>
                                        <Select
                                            isMulti
                                            inputId="copyrightAndAccess"
                                            options={copyrightAndAccessOptions}
                                            value={copyrightAndAccessOptions.filter((option) => responseData.applicableFields && responseData.copyrightAndAccess.length > 0
                                                ? responseData.copyrightAndAccess.includes(option.value)
                                                : false
                                            )}
                                            onChange={(selectedOptions) =>
                                                handleMultiSelectChange('copyrightAndAccess', selectedOptions)
                                            }

                                            className="mt-1"
                                        />
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="copyrightandAccessDetailsandContact" className="block text-sm font-medium text-gray-700">Copyright and Access Details and Contact </label>
                                        <input
                                            type="text"
                                            id="copyrightandAccessDetailsandContact"
                                            name="copyrightandAccessDetailsandContact"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.copyrightandAccessDetailsandContact}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="linkToTool" className="block text-sm font-medium text-gray-700">Link to the Tool</label>
                                        <input
                                            type="text"
                                            id="linkToTool"
                                            name="linkToTool"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.linkToTool}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="contactInformation" className="block text-sm font-medium text-gray-700">Contact Information</label>
                                        <input
                                            type="text"
                                            id="contactInformation"
                                            name="contactInformation"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.contactInformation}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="originalPopulation" className="block text-sm font-medium text-gray-700">Original Population</label>
                                        <input
                                            type="text"
                                            id="originalPopulation"
                                            name="originalPopulation"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.originalPopulation}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="additionalPopulations" className="block text-sm font-medium text-gray-700">Additional Populations</label>
                                        <input
                                            type="text"
                                            id="additionalPopulations"
                                            name="additionalPopulations"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.additionalPopulations}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="originalSetting" className="block text-sm font-medium text-gray-700">Original Setting</label>
                                        <input
                                            type="text"
                                            id="originalSetting"
                                            name="originalSetting"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.originalSetting}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="additionalSetting" className="block text-sm font-medium text-gray-700">Additional Setting</label>
                                        <input
                                            type="text"
                                            id="additionalSetting"
                                            name="additionalSetting"
                                            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                                            value={responseData.additionalSetting}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="overallLevelofEvidence" className="block text-sm font-medium text-gray-700">Overall Level of Evidence</label>
                                        <Select
                                            inputId="overallLevelofEvidence"
                                            options={levelOfEvidenceOptions}
                                            value={levelOfEvidenceOptions.find((option) => option.value === responseData.overallLevelofEvidence)}
                                            onChange={(value) => handleSelectChange('overallLevelofEvidence', value)}
                                            className="mt-1"
                                        />
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="areasofStrength" className="block text-sm font-medium text-gray-700">Areas of Strength</label>
                                        <Editor
                                            editorState={editorState['areasofStrength']}
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('areasofStrength', newEditorState)}
                                        />

                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="recommendationsforFurtherValidation" className="block text-sm font-medium text-gray-700">Recommendations for Further Validation</label>
                                        <Editor
                                            editorState={editorState['recommendationsforFurtherValidation']}
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('recommendationsforFurtherValidation', newEditorState)}
                                        />
                                    </div>


                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === 1 && (


                        <div class="flex flex-wrap -mx-3 mb-6 p-8">


                            <div className="mb-6 border-b pb-6">

                                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                                    <div className="form-group">
                                        <label htmlFor="references" className="block text-sm font-medium text-gray-700">References</label>
                                        <Editor
                                            editorState={editorState['references']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('references', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>




                                    <div className="form-group">
                                        <label htmlFor="levelOfEvidence" className="block text-sm font-medium text-gray-700">Level of Evidence</label>
                                        <Select
                                            inputId="levelOfEvidence"
                                            options={levelOfEvidenceOptions}
                                            value={levelOfEvidenceOptions.find((option) => option.value === responseData.levelOfEvidence)}
                                            onChange={(value) => handleSelectChange('levelOfEvidence', value)}
                                            className="mt-1"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="dimension1UsefulnessRating" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Rating</label>
                                        <Select
                                            inputId="dimension1UsefulnessRating"
                                            options={ratingresultOptions}
                                            value={ratingresultOptions.find((option) => option.value === responseData.dimension1UsefulnessRating)}
                                            onChange={(value) => handleSelectChange('dimension1UsefulnessRating', value)}
                                            className="mt-1"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="dimension1UsefulnessStrength" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Areas of Strength</label>
                                        <Editor
                                            editorState={editorState['dimension1UsefulnessStrength']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension1UsefulnessStrength', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="dimension1UsefulnessSupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Supporting Documentation</label>
                                        <Editor
                                            editorState={editorState['dimension1UsefulnessSupportingDocs']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension1UsefulnessSupportingDocs', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>



                                    <div className="form-group">
                                        <label htmlFor="dimension1UsefulnessRecommendations" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Recommendations for Further Validation</label>
                                        <Editor
                                            editorState={editorState['dimension1UsefulnessRecommendations']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension1UsefulnessRecommendations', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>



                                    <div className="form-group">
                                        <label htmlFor="dimension2ReliabilityRating" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability Rating Results </label>
                                        <Select
                                            inputId="dimension2ReliabilityRating"
                                            options={ratingresultOptions}
                                            value={ratingresultOptions.find((option) => option.value === responseData.dimension2ReliabilityRating)}
                                            onChange={(value) => handleSelectChange('dimension2ReliabilityRating', value)}
                                            className="mt-1"
                                        />
                                    </div>



                                    <div className="form-group">
                                        <label htmlFor="dimension2ReliabilityStrength" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability Areas of Strength</label>
                                        <Editor
                                            editorState={editorState['dimension2ReliabilityStrength']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension2ReliabilityStrength', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="dimension2ReliabilitySupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability
                                            Supporting Documentation</label>
                                        <Editor
                                            editorState={editorState['dimension2ReliabilitySupportingDocs']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension2ReliabilitySupportingDocs', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>



                                    <div className="form-group">
                                        <label htmlFor="dimension2ReliabilityRecommendations" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability
                                            Recommendations for Further Validation</label>
                                        <Editor
                                            editorState={editorState['dimension2ReliabilityRecommendations']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension2ReliabilityRecommendations', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="dimension3ValidityRating" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Rating Results</label>
                                        <Select
                                            inputId="dimension3ValidityRating"
                                            options={ratingresultOptions}
                                            value={ratingresultOptions.find((option) => option.value === responseData.dimension3ValidityRating)}
                                            onChange={(value) => handleSelectChange('dimension3ValidityRating', value)}
                                            className="mt-1"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="dimension3ValidityStrength" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Areas of Strength</label>
                                        <Editor
                                            editorState={editorState['dimension3ValidityStrength']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension3ValidityStrength', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="dimension3ValiditySupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Supporting Documentation</label>
                                        <Editor
                                            editorState={editorState['dimension3ValiditySupportingDocs']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension3ValiditySupportingDocs', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>




                                    <div className="form-group">
                                        <label htmlFor="dimension3ValidityRecommendations" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Recommendations for Further Validation </label>
                                        <Editor
                                            editorState={editorState['dimension3ValidityRecommendations']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension3ValidityRecommendations', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>



                                    <div className="form-group">
                                        <label htmlFor="dimension4CriterionValidityRating" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Rating Results</label>
                                        <Select
                                            inputId="dimension4CriterionValidityRating"
                                            options={ratingresultOptions}
                                            value={ratingresultOptions.find((option) => option.value === responseData.dimension4CriterionValidityRating)}
                                            onChange={(value) => handleSelectChange('dimension4CriterionValidityRating', value)}
                                            className="mt-1"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="dimension4CriterionValidityStrength" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Areas of Strength</label>
                                        <Editor
                                            editorState={editorState['dimension4CriterionValidityStrength']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension4CriterionValidityStrength', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="dimension4CriterionValiditySupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Supporting Documentation</label>
                                        <Editor
                                            editorState={editorState['dimension4CriterionValiditySupportingDocs']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension4CriterionValiditySupportingDocs', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>



                                    <div className="form-group">
                                        <label htmlFor="dimension4CriterionValidityRecommendations" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Recommendations for Further Validation</label>
                                        <Editor
                                            editorState={editorState['dimension4CriterionValidityRecommendations']} // Dynamically set the editorState for each field
                                            toolbarCustomButtons={[<doCollapse />]}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            toolbarClassName="demo-toolbar-absolute"
                                            toolbarOnFocus
                                            onEditorStateChange={(newEditorState) => onEditorStateChange('dimension4CriterionValidityRecommendations', newEditorState)} // Pass the field name to handle changes
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="form-group">
                        <div className="grid grid-cols-1 gap-6 lg:grid-cols-1 mb-8">

                            <div className="mx-auto">
                                {/*  <button class="bg-blue-500 hover:bg-blue-700 text-white  py-2 px-4 text-sm rounded"
                onClick={e => setResponseData({ ...responseData, nid: responseID._id })
                }>Update Content </button> */}


                                <button
                                    type="submit"
                                    className="bg-blue-700 hover:bg-blue-500 text-white  py-2 px-4 text-sm rounded mx-auto"
                                    onClick={e => setResponseData({ ...responseData, id: responseID._id, nid: responseData.nid })}>
                                    {loading && (
                                        <i
                                            className="fa fa-refresh fa-spin"
                                            style={{ marginRight: "5px" }}
                                        />
                                    )}
                                    {loading && <span>Processing Request</span>}
                                    {!loading && <span>Update Content</span>}

                                </button>

                            </div>
                        </div>
                    </div>

                </form>

            </div>
        </div>
    );
}

export default EditOneRecord;
